export default "__VITE_ASSET__CyF$3tqA__"